// extracted by mini-css-extract-plugin
export var numpadContainer = "_p4-1";
export var phoneButton = "_p4-0";